import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const WhoItsForSection = () => {
  const [visible, setVisible] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          [0,1,2].forEach((i) => setTimeout(() => setVisible(v => [...v, i]), i * 130));
          obs.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  const personas = [
    {
      id: 'emotions',
      icon: 'Sun',
      title: 'Manage Emotions',
      description: 'For understanding your feelings, calming your inner world, and responding instead of reacting.',
      color: 'from-yellow-500/20 to-orange-500/20'
    },
    {
      id: 'source',
      icon: 'Compass',
      title: 'Connect to Source',
      description: 'For feeling grounded, guided, and connected to something deeper than daily stress.',
      color: 'from-violet-500/20 to-purple-500/20'
    },
    {
      id: 'abundance',
      icon: 'Sparkles',
      title: 'Attract Abundance',
      description: 'For shifting limiting beliefs, building self-worth, and opening yourself to growth and possibility.',
      color: 'from-emerald-500/20 to-teal-500/20'
    }
  ];

  return (
    <section id="who-its-for" ref={sectionRef} className="relative py-24 px-6 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img src="/image1.jpg" alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-transparent to-background/30" />
      </div>
      <div className="absolute inset-0 cosmic-gradient opacity-15 pointer-events-none" />
      
      <div className="relative z-10 max-w-5xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            What do you want to <span className="text-gradient">work on?</span>
          </h2>
        </div>

        {/* Personas Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {personas?.map((persona) => (
            <div
              key={persona?.id}
              className={`glassmorphism p-8 rounded-2xl hover:scale-105 transition-all duration-500 group ${visible.includes(personas.indexOf(persona)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${personas.indexOf(persona) * 130}ms` }}
            >
              {/* Icon */}
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${persona?.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={persona?.icon} size={28} className="text-primary" />
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-foreground mb-4">
                {persona?.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {persona?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;